/**
 * Titel, Beschreibung und Canonical je Seite. Die Startseite steht zusätzlich statisch in der
 * index.html (siehe scripts/prerender.mjs), damit Suchmaschinen sie auch ohne JavaScript lesen.
 */
import { useEffect } from 'react';
import { SITE } from '../content/landing';

type Meta = { title: string; description: string; noindex?: boolean };
export const PAGES: Record<string, Meta> = {
  '/': { title: SITE.title, description: SITE.description },
  '/spiel': { title: 'Spielen – Kabinett', description: 'Starte deine Partie: Partei gründen, Wahlkampf führen, Koalition schmieden und regieren.' },
  '/hilfe': { title: "So funktioniert's – Kabinett", description: 'Spielanleitung für Kabinett: Wahlprogramm, Wahlkampf, Koalition, Gesetze, Haushalt, Verwaltung, Kommunikation und Opposition erklärt.' },
  '/bestenliste': { title: 'Bestenliste – Kabinett', description: 'Die besten Regierungen in Kabinett: Amtszeit, Wahlergebnisse, beschlossene Gesetze und Lage des Landes.' },
  '/mitspielen': { title: 'Zu zweit spielen – Kabinett', description: 'Spiel Kabinett zu zweit: mit zwei Parteien gegeneinander oder gemeinsam in einer Regierung.' },
  '/profil': { title: 'Anmelden – Kabinett', description: 'Melde dich an, um Spielstände in der Cloud zu speichern, in die Bestenliste zu kommen und mit anderen zu spielen.', noindex: true },
  '/orden': { title: 'Orden – Kabinett', description: 'Alle Orden in Kabinett: Auszeichnungen für Wiederwahl, Schwarze Null, Verfassungsmehrheit, Krisenfestigkeit und mehr.' },
  '/neu': { title: 'Was ist neu – Kabinett', description: 'Alle Neuerungen in Kabinett: neue Spielregeln, Funktionen und Verbesserungen, neueste zuerst.' },
  '/impressum': { title: 'Impressum – Kabinett', description: 'Impressum von Kabinett.' },
  '/datenschutz': { title: 'Datenschutz – Kabinett', description: 'Datenschutzerklärung von Kabinett.' },
};

function setMeta(sel: string, attr: 'content' | 'href', val: string, create: () => HTMLElement) {
  let el = document.head.querySelector(sel) as HTMLElement | null;
  if (!el) { el = create(); document.head.appendChild(el); }
  el.setAttribute(attr, val);
}
const metaEl = (k: 'name' | 'property', v: string) => () => { const m = document.createElement('meta'); m.setAttribute(k, v); return m; };

export function usePageMeta(path: string) {
  useEffect(() => {
    const m = PAGES[path] ?? PAGES['/'], url = SITE.url + (path === '/' ? '/' : path);
    document.title = m.title;
    setMeta('meta[name="description"]', 'content', m.description, metaEl('name', 'description'));
    setMeta('meta[name="robots"]', 'content', m.noindex ? 'noindex, follow' : 'index, follow', metaEl('name', 'robots'));
    setMeta('link[rel="canonical"]', 'href', url, () => { const l = document.createElement('link'); l.rel = 'canonical'; return l; });
    setMeta('meta[property="og:url"]', 'content', url, metaEl('property', 'og:url'));
    setMeta('meta[property="og:title"]', 'content', m.title, metaEl('property', 'og:title'));
    setMeta('meta[property="og:description"]', 'content', m.description, metaEl('property', 'og:description'));
  }, [path]);
}
